module.exports = __webpack_public_path__ + "files/82332c98e999ea99a35dfca49e07f11f.png";